module.exports = __webpack_public_path__ + "img/champions.cb5891f0.png";